import { siteInfo } from '@/mocks/homeData';

const heroImage = 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20composition%20of%20Chinese%20drama%20and%20film%20elements%20with%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20film%20strip%20curves%2C%20soft%20lens%20flares%2C%20modern%20minimalist%20streaming%20platform%20visual%2C%20clean%20dark%20background%20with%20warm%20accents%2C%20entertainment%20technology%20aesthetic%2C%20premium%20cinematic%20atmosphere&width=900&height=700&seq=hero-main-2026&orientation=landscape';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="麻花视频 - 高清电视剧电影在线观看平台"
          className="w-full h-full object-cover object-top opacity-40"
          onError={(e) => {
            (e.target as HTMLElement).style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/70"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <p className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium mb-5 tracking-wide whitespace-nowrap">
              {siteInfo.tagline}
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-5">
              麻花视频
              <span className="block text-primary-400 mt-2">免费高清电视剧在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-300 font-medium mb-4">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                    <span className="text-base md:text-lg text-accent-500">{stat.suffix}</span>
                  </div>
                  <div className="text-xs md:text-sm text-foreground-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#about');
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer no-underline"
              >
                开始追剧
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#app');
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium border border-background-300/40 text-background-100 rounded-lg hover:bg-background-50/10 hover:border-background-200/60 transition-all duration-200 text-center whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-download-2-line mr-2"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full max-w-[420px] lg:max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src={heroImage}
                alt="麻花视频平台主视觉 - 海量影视内容展示"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-200/20"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-background-950/80 to-transparent">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                  <div>
                    <p className="text-background-50 text-sm font-medium">锦绣风华录</p>
                    <p className="text-foreground-300 text-xs">第48集 · 大结局</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}